"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeamSelector = void 0;

var _react = _interopRequireDefault(require("react"));

var _async = _interopRequireDefault(require("react-select/async"));

var _atoms = require("../../atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TeamSelector = function TeamSelector(props) {
  var itemStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  };
  var itemBadgeStyles = {
    backgroundColor: '#EBECF0',
    borderRadius: '2em',
    color: '#172B4D',
    display: 'inline-block',
    fontSize: 12,
    fontWeight: 'normal',
    lineHeight: '1',
    minWidth: 1,
    padding: '0.17em 0.5em',
    textAlign: 'center',
    marginLeft: '1em'
  };
  var customStyles = {
    control: function control(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        height: "50px",
        borderRadius: "0",
        borderWidth: "2px"
      });
    }
  };

  var itemFormatLabel = function itemFormatLabel(data) {
    return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
      style: itemStyles
    }, /*#__PURE__*/_react.default.createElement(_atoms.Label, null, data.title), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      style: itemBadgeStyles
    }, data.games, " ", data.games !== 1 ? "games" : "game"));
  };

  var promiseOptions = function promiseOptions(inputValue, callback) {
    if (props.handleOnChange) {
      props.handleOnChange(inputValue).then(function (data) {
        callback(data);
      });
    } else {
      callback(props.teams);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: props.className
  }, /*#__PURE__*/_react.default.createElement(_async.default, {
    className: "team-selector",
    cacheOptions: true,
    loadOptions: promiseOptions,
    defaultOptions: true,
    styles: customStyles,
    value: props.selectedTeam,
    onChange: props.handleInputChange,
    placeholder: "Find a team",
    formatOptionLabel: itemFormatLabel,
    getOptionValue: function getOptionValue(item) {
      return item.team_id.toString();
    },
    autoFocus: props.focus,
    defaultMenuIsOpen: props.focus,
    theme: function theme(_theme) {
      return _objectSpread(_objectSpread({}, _theme), {}, {
        colors: _objectSpread(_objectSpread({}, _theme.colors), {}, {
          primary: '#37C2AC',
          primary25: '#d2ffe4'
        })
      });
    }
  }));
};

exports.TeamSelector = TeamSelector;